module.exports = __webpack_public_path__ + "media/images/gallery/ir-8e39333787631d2f5e5be3bd80bab355.png";